import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#19bf82',
      contrastText: '#fff',
    },
    success: {
      main: '#19bf82',
      contrastText: '#fff',
    },
    warning: {
      main: '#f5c022',
      contrastText: '#fff',
    },
    error: {
      main: '#cf5151',
      contrastText: '#fff',
    },
    info: {
      main: '#679fd9',
      contrastText: '#fff',
    },
  },
});

export default theme;
